import React, { useEffect } from 'react';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { LookInside } from './components/LookInside';
import { Bonuses } from './components/Bonuses';
import { NotEbook } from './components/NotEbook';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PIXEL_ID } from './data/constants';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3rcj7c4kla37o">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="3rbzomln47asl" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-steel antialiased" data-id="element-2" data-mp="2zmeo498kfm81">
        {showPurchasePopup && <PurchasePopup data-id="element-3" data-mp="33oriy2lrxzq1" />}
        <main data-id="element-4" data-mp="38lrs4mdx7ild">
          <Hero data-id="element-5" data-mp="38l8h7pmotugu" />
          <PainSection data-id="element-6" data-mp="38kqbm2e4y3w9" />
          <SystemSection data-id="element-7" data-mp="38kgkucl9nspi" />
          <LookInside data-id="element-8" data-mp="38o4ct7b2c724" />
          <Bonuses data-id="element-9" data-mp="3dle3eqa6uorj" />
          <NotEbook data-id="element-10" data-mp="3dlw4q1bpjt6b" />
          <Offer data-id="element-11" data-mp="3dmfmni1cyhkc" />
          <Guarantee data-id="element-12" data-mp="3dirxsw6uyjby" />
          <Testimonials data-id="element-13" data-mp="nvsup6ui4rx0" />
          <FAQ data-id="element-14" data-mp="nuhg0bzipzr4" />
          <FinalCTA data-id="element-15" data-mp="nuraocvicv35" />
        </main>
        <Footer data-id="element-16" data-mp="nxwvhfx3tat2" />
      </div>
    </>;
}
function initMetaPixel() {
  const pixelWindow = window as PixelWindow;
  try {
    if (!pixelWindow.fbq) {
      const fbq = ((...args: unknown[]) => {
        if (fbq.callMethod) {
          fbq.callMethod(...args);
        } else {
          fbq.queue?.push(args);
        }
      }) as PixelFunction;
      pixelWindow.fbq = fbq;
      if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    }
    pixelWindow.fbq?.('init', PIXEL_ID);
    pixelWindow.fbq?.('track', 'PageView');
  } catch (error) {
    console.warn('Meta Pixel init skipped:', error);
  }
}